export default class ValidationService {
  public static isNotEmpty(value: string): boolean {
    return !!value;
  }

  public static isEmail(value: string): boolean {
    return ValidationService.validate(
      /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/,
      value,
    );
  }

  public static isPhone(value: string): boolean {
    return ValidationService.validate(
      /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/,
      value,
    );
  }

  public static isZipCode(value: string): boolean {
    return ValidationService.validate(/^[0-9]{5}(-[0-9]{4})?$/, value);
  }

  public static isHandle(value: string): boolean {
    return ValidationService.validate(/^@([a-zA-Z0-9 ._-]+)$/, value);
  }

  public static isName(value: string): boolean {
    return ValidationService.validate(/[\p{Letter}\p{Mark}\s-]+/gu, value);
  }

  public static isNPI(value: string): boolean {
    return value[0] !== '0' && ValidationService.isCurrentLength(value, 10);
  }

  public static isCurrentLength(value: string, length: number): boolean {
    return value.length === length;
  }

  public static isLonger(value: string, length: number): boolean {
    return ValidationService.validate(new RegExp(`.{${length},}`), value);
  }

  public static containsCapitalLetter(value: string): boolean {
    return ValidationService.validate(/[A-Z]+/, value);
  }

  public static containsSpecialCharacter(value: string): boolean {
    return ValidationService.validate(/[!@#$%^&*(),.?":{}|<>]+/, value);
  }

  public static containsNumeric(value: string): boolean {
    return ValidationService.validate(/[0-9]+/, value);
  }

  public static onlyNumbers(value: string): boolean {
    return ValidationService.validate(/^[0-9]*$/, value);
  }

  public static containsLetters(value: string): boolean {
    return ValidationService.validate(/[a-zA-Z]/, value);
  }

  public static maxLength(value: string, length: number): boolean {
    return ValidationService.validate(new RegExp(`^.{0,${length}}$`), value);
  }

  private static validate(pattern: RegExp, value: string): boolean {
    return pattern.test(value);
  }
}
